import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useGetWorkOutById } from "../../api/useProducts/useWorkOut";
import { Sidebar } from "../../components";
import Loader from "../../components/Loader";
import VideoCard from "../../components/VideoCard";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";

const WorkoutDetail = () => {
  const { workoutId } = useParams();
  const { WorkoutData, WorkoutLoading, WorkoutRefetch } = useGetWorkOutById(
    Number(workoutId)
  );

  // Refetch workout data whenever workoutId changes
  useEffect(() => {
    WorkoutRefetch();
  }, [workoutId]);

  const breadcrumbItems = [
    { title: "Workouts", link: "workouts" },
    { title: "Detail " },
  ];
  return (
    <Sidebar>
      <div className="mt-3">
        <CustomBreadcrumb items={breadcrumbItems} />
      </div>
      {WorkoutLoading ? (
        <div className="h-[80vh] flex justify-center items-center">
          <Loader />
        </div>
      ) : (
        <div className="mt-3">
          {/* Workout Title */}
          <h1 className="text-3xl font-bold">{WorkoutData?.title}</h1>

          {WorkoutData?.media && (
            <div className="mt-5">
              <img
                src={WorkoutData?.media}
                alt="Workout Media"
                className=" border w-full max-h-96 rounded-2xl shadow-lg object-cover"
              />
            </div>
          )}
          <br />
          <div className="border-b-2 flex">
            <span className="border-b-[3.5px] border-darkCyan ms-4 font-medium px-3 pb-2 translate-y-[2px]">
              Overview
            </span>
          </div>

          {/* Workout Details */}
          <div className="mt-5 flex flex-wrap  gap-3 justify-between items-center border-b-2 pb-4">
            <p>
              <span className="font-medium">Category:</span>{" "}
              {WorkoutData?.category}
            </p>
            <p>
              <span className="font-medium">Calories:</span>{" "}
              {WorkoutData?.calories}
            </p>
            <p>
              <span className="font-medium">Points:</span> {WorkoutData?.points}
            </p>
            <p>
              <span className="font-medium">Level:</span> {WorkoutData?.level}
            </p>
          </div>
          {/* Workout Description */}
          {WorkoutData?.description && (
            <div className="mt-5">
              <h3 className=" font-medium">Description</h3>
              <br />
              <p className=" text-base">
                <div
                  className="mt-2"
                  dangerouslySetInnerHTML={{ __html: WorkoutData?.description }}
                />
              </p>
            </div>
          )}
          <br />
          {/* Exercises in this workout */}
          {WorkoutData?.workoutExercises &&
            WorkoutData?.workoutExercises?.length > 0 && (
              <div>
                <h3 className="text-xl font-semibold">Workout Exercises</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-3">
                  {WorkoutData?.workoutExercises?.map((workoutExercise) => (
                    <div key={workoutExercise?.id}>
                      <VideoCard
                        media={workoutExercise?.exercise?.video}
                        description={workoutExercise?.exercise?.instructions}
                        title={workoutExercise?.exercise?.title}
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
          <br />
          <h3 className="text-xl font-semibold mb-3">Users</h3>
          {WorkoutData?.userWorkouts &&
          WorkoutData?.userWorkouts?.length > 0 ? (
            <div className="">
              <div className="flex flex-wrap gap-3">
                {WorkoutData?.userWorkouts.map((user, idx) => {
                  return (
                    <div className=" text-center">
                      <img
                        src={user.user.profile_image || "/images/profile.jpg"}
                        alt="image not found"
                        className="w-20 h-20 rounded-xl object-cover"
                      />
                      <p
                        title={user?.user?.fullName}
                        className="text-sm truncate overflow-hidden whitespace-nowrap max-w-[80px]"
                      >
                        {user?.user?.fullName}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center">
              <img
                src="/images/user-not-found.png"
                className="w-32 h-32"
                alt="image not found"
              />
              <p className="text-lg font-semibold text-[#D9D9D9]">
                No User right now!
              </p>
            </div>
          )}
        </div>
      )}
    </Sidebar>
  );
};

export default WorkoutDetail;
